import { generatePath, useNavigate, useParams } from "react-router-dom";
import { RoutePath } from "../routerPaths";
import { CrmLoadError } from "./components/CrmLoadError";
import { RecordFormPageLayout, RecordFormSkeleton } from "./form/components/RecordFormPageLayout";
import { RecordForm } from "./form/RecordForm";
import { useRecordEditor } from "./form/useRecordEditor";

export function CrmEditRecordPage() {
  const { recordId = "" } = useParams<{ recordId: string }>();
  const navigate = useNavigate();
  const recordPath = generatePath(RoutePath.CrmRecord, { recordId });
  const editor = useRecordEditor({
    target: { record_id: recordId },
    onSaved: () => navigate(recordPath),
  });

  if (editor.status === "loading") {
    return (
      <RecordFormPageLayout breadcrumbs={[{ label: "CRM", to: RoutePath.CrmList }, { label: "Edit" }]} title="Edit record">
        <RecordFormSkeleton />
      </RecordFormPageLayout>
    );
  }
  if (editor.status === "error") {
    return <CrmLoadError subject="record" isRetrying={editor.isRetrying} onRetry={editor.retry} />;
  }

  const { master, record, version, form } = editor;
  return (
    <RecordFormPageLayout
      breadcrumbs={[
        { label: "CRM", to: RoutePath.CrmList },
        { label: master.long_name, to: generatePath(RoutePath.CrmGroup, { masterId: master.id }) },
        { label: record.long_name, to: recordPath },
        { label: "Edit" },
      ]}
      title={`Edit ${record.long_name}`}
      subtitle={`Record Group: ${master.long_name}`}
    >
      <RecordForm
        key={version}
        mode="update"
        {...form}
        lockedFields={{ master_id: true }}
        onCancel={() => navigate(recordPath)}
      />
    </RecordFormPageLayout>
  );
}
